export enum TriggerType {
  VCS = 'vcsTrigger',
  SCHEDULE = 'schedulingTrigger',
}

export enum TriggerSchedulingPolicy {
  WEEKLY = 'weekly-with-several-days',
  DAILY = 'daily',
}
